<div class="account-item-widget app-red-card"
    ng-class="{'card-item-widget-disabled': card.temporaryStatus || card.cardStatus != 'Active'}">
    <span class="account-widget-icon" ng-style="{'background-image': 'url(img/' + card.cardType + '.svg)'}"></span>
    <h4 class="acc-name c-white fw-600">
        {{card.cardTypeDescription}}
    </h4>
    <h5 class="c-white card-number-wrap mb-1 mt-1">
        <span class="f-14 card-number no-wrap-text">{{vm.formatCardNumber(card.cardNumber)}}</span>
    </h5>
    <div class="c-white">
        <div class="f-14 no-wrap-text">{{card.ownerName}}</div>
        <div><span translate="cards.expiryDate"></span>: {{card.expiryMonth }}.{{card.expiryYear}}.</div>
    </div>


</div>
<!--  -->
<div ng-if="card.temporaryStatus || card.cardStatus != 'Active'" class="bg-addiko-blue c-white card-status-track">
    <span translate="cards.status"></span>:
    {{('cards.statuses.' + (card.temporaryStatus || card.cardStatus)) | translate}}
</div>